import React from 'react';
import { FiArrowRight, FiInstagram, FiPhone } from 'react-icons/fi';

import { MenuViewer, ServiceSection } from '../../components';
import { contacts, images } from '../../constants';

export const Caffetteria = () => (
  <ServiceSection
    id="caffetteria"
    eyebrow="Caffetteria"
    headline="Inizia la giornata con qualcosa di speciale."
    paragraphs={[
      'Una buona colazione è il modo migliore per iniziare la giornata.',
      'Da L’angolo verde ti aspettiamo con caffè, cappuccini, croissant, dolci e tante proposte golose, per una colazione veloce o per un momento da gustare con calma.',
      'Ci piace rendere speciale anche il primo momento della giornata.',
    ]}
    rows={[
      [{ image: images.cappuccino, alt: 'Cappuccino e croissant serviti al tavolo' }],
      [
        { image: images.bancone, alt: 'Il bancone con la macchina del caffè e i vassoi di cornetti' },
        { image: images.cornetti, alt: 'Vassoi di cornetti e dolci da colazione' },
      ],
    ]}
  >
    <div className="service__actions">
      <a href="#contatti" className="btn btn--primary">
        Vieni a trovarci
        <FiArrowRight aria-hidden="true" />
      </a>
      <MenuViewer
        label="Sfoglia il menù"
        title="Menù caffetteria e pasticceria"
        image={images.menuCaffetteria}
        alt="Menù di caffetteria, pasticceria e mini pasticceria con i relativi prezzi"
      />
    </div>
  </ServiceSection>
);

export const PausaPranzo = () => (
  <ServiceSection
    id="pausa-pranzo"
    tone="sand"
    reverse
    eyebrow="Pausa pranzo"
    headline="Ogni giorno qualcosa di buono."
    paragraphs={[
      'Per la tua pausa pranzo proponiamo un menù ricco e sfizioso, pensato per offrirti gusto e varietà.',
      'E perché ci piace sorprenderti, troverai anche i nostri fuori menù, che cambiano e si rinnovano per portare sempre qualcosa di nuovo in tavola.',
      'La tua pausa pranzo, ogni giorno un po’ diversa.',
    ]}
    rows={[
      [
        { image: images.piadina, alt: 'Piadina farcita con insalata e un bicchiere di succo' },
        { image: images.hamburger, alt: 'Panino hamburger con patatine fritte' },
      ],
    ]}
  >
    <div className="service__actions">
      <a href={contacts.phoneHref} className="btn btn--primary">
        <FiPhone aria-hidden="true" />
        Chiedici il menù del giorno
      </a>
      <MenuViewer
        label="Sfoglia il menù"
        title="Menù pranzo"
        image={images.menuPranzo}
        alt="Menù pranzo con panini, insalatone, piadine, toast, primi e secondi piatti con i relativi prezzi"
      />
    </div>
  </ServiceSection>
);

export const Aperitivi = () => (
  <ServiceSection
    id="aperitivi"
    tone="dark"
    eyebrow="Condividi momenti speciali."
    headline="Un aperitivo da vivere insieme."
    paragraphs={[
      'Durante la pausa pranzo vuoi organizzare un momento speciale da condividere con amici, parenti o con chi vuoi?',
      'Chiedici informazioni per creare un aperitivo su misura, pensato per te, per i tuoi gusti e per l’occasione.',
      'Che sia un compleanno, una ricorrenza o semplicemente il piacere di stare insieme, ti aiutiamo a rendere speciale il tuo momento.',
    ]}
    rows={[
      [{ image: images.aperitivoTavolo, alt: 'Tagliere di salumi e formaggi con due spritz su un tavolo di legno' }],
      [
        { image: images.aperitivoTagliere, alt: 'Aperitivo con tagliere, stuzzichini e drink all’aperto' },
        { image: images.aperitivoSpritz, alt: 'Due spritz con stuzzichini e patatine' },
      ],
    ]}
  >
    <p className="service__highlight">Tu scegli la compagnia, noi pensiamo all’aperitivo.</p>
    <div className="service__actions">
      <a href={contacts.phoneHref} className="btn btn--light">
        <FiPhone aria-hidden="true" />
        Organizza il tuo aperitivo
      </a>
      <a
        href={contacts.instagramUrl}
        className="btn btn--outline-light"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FiInstagram aria-hidden="true" />
        Scrivici su Instagram
      </a>
    </div>
  </ServiceSection>
);
